import React, { lazy, Suspense } from 'react';
import LoadingIndicator from '@wix/da-ds/pkg/LoadingIndicator';
import ErrorBoundary from '@wix/da-react-context/pkg/ErrorBoundary';
import retry from '@wix/da-shared-react/pkg/utils/webpack/chunkRetry';

const LoadableRedux = lazy(() =>
  retry(
    () =>
      import(
        /* webpackChunkName: "deviationsubmitpopup" */
        '../../redux/ModuleLoadable'
      )
  )
);

const LoadableDeviationSubmitPopup = lazy(() =>
  retry(
    () =>
      import(
        /* webpackChunkName: "deviationsubmitpopup" */
        './DeviationSubmitPopup'
      )
  )
);

interface Props {
  deviationId?: number;
  requestClose: () => void;
}

const LazyDeviationSubmitPopup: React.FC<Props> = props => (
  <ErrorBoundary debugComponent="LazyDeviationSubmitPopup">
    <Suspense
      fallback={<LoadingIndicator view={'llama'} withOverlay usePortal />}
    >
      <LoadableRedux />
      <LoadableDeviationSubmitPopup {...props} />
    </Suspense>
  </ErrorBoundary>
);
LazyDeviationSubmitPopup.displayName = 'LazyDeviationSubmitPopup';

export default LazyDeviationSubmitPopup;
